import * as React from "react";

import { BlockProps } from "baseui/block";
import { DisplayLabel } from "./DisplayLabel";

type TAnzsicDisplay = {
  answer: {
    label: string;
  };
} & BlockProps;

export const AnzsicDisplay: React.FC<TAnzsicDisplay> = ({ answer, ...restProps }) => (
  <DisplayLabel {...restProps}>{answer.label}</DisplayLabel>
);
